import React, { useEffect, useRef } from 'react';
import { readCookie } from '../../../utils/Cookie';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';

export function maskEmailID(emailID = '') {
  const findAtTheRate = emailID.indexOf('@'); // Get the index of character before "@"
  const countNoOfChar = emailID.substring(0, findAtTheRate).length; // get the no. of string before @

  if (countNoOfChar < 2) {
    return emailID;
  }

  const maskStr = emailID.split('');
  for (let i = 1; i < findAtTheRate - 1; i++) {
    maskStr[i] = '*';
  }

  return maskStr.join('');
}

const MAX_OTP_ATTEMPTS = 3;

export default (props = {}) => {
  const {
    otp = '',
    message = '',
    statusCode = '',
    secondsRemaining = '',
    enableResendOTP = '',
    otpSendAgain = false,
    app = '',
    otp_popup_display_email = false,
    otp_popup_display_mobile = true,
    VerificationPage,
    otpAttemptCount = 0,
    onBackToOrderDetails
  } = props;

  const attemptsLeft = MAX_OTP_ATTEMPTS - otpAttemptCount;
  const otpLimitExceeded = otpAttemptCount >= MAX_OTP_ATTEMPTS;
  const headerRef=useRef();
  let {
    personalInfo: { profile: { mobileNumber = '', displayUid: emailId = '', uid = '' } = {} } = {}
  } = props;

  const userCookieData = {
    mobileNumber: decodeURIComponent(readCookie('MN')),
    emailId: decodeURIComponent(readCookie('U'))
  }

  uid = uid || userCookieData.emailId;
  emailId = emailId || userCookieData.emailId;
  mobileNumber = mobileNumber || userCookieData.mobileNumber;

  const { otpTitle, otpDescription, otpSubmitBtn = '' } = props;
  const USER_MOBILE_NUMBER = mobileNumber;
  const USER_EMAIL_ID = maskEmailID(uid);

  const label = {
    userProfileOtp: `${otpTitle}`,
    userDetail: otp_popup_display_email
      ? `${otpDescription} <span>${emailId}</span>`
      : `${otpDescription}</br><span> +91 ${USER_MOBILE_NUMBER}</span>`,
    otpLabel: 'Enter OTP',
    valid: 'Valid for 10 mins',
    resendOtp: 'Resend OTP',
    resendTime: `Resend OTP in <span style="color:#866528">${secondsRemaining}s</span>`,
    submit: 'CONFIRM OTP',
    incorrectOTP: 'Incorrect OTP entered. Please try again',
    incorrectOtp3rd: 'Incorrect OTP entered. Please try after sometime or call or contact centre',
    attemptsExceeded:
      'OTP attempts exceeded. Your return request has been cancelled. Please initiate the return again.',

    enterNewPhoneHeader: 'Enter New Phone Number',
    newPhoneNumber: 'Enter New Phone Number',
    newEmail: 'Enter New Email Id',
    submitNewNumber: 'Send otp for verification',

    changePhoneNumberHeader: 'Enter OTP To Change Phone Number',
    changePhoneNumber: `Enter OTP sent to the new phone number +91 ${USER_MOBILE_NUMBER}`
  };

  console.log('🚀 ~ file: personal-info-user-otp.js:53 ~ message=======', message);
  const ERROR_MESSAGE = otpLimitExceeded ? label.attemptsExceeded : (message || label.valid);
  const CUSTOM_ERROR_CLASS = (message || otpLimitExceeded) ? 'invalid-otp' : '';
  const RESEND_LABEL = otpLimitExceeded ? label.resendOtp : (secondsRemaining > 0 ? label.resendTime : label.resendOtp);
  const CUSTOM_RESEND = secondsRemaining === 0 && !otpLimitExceeded ? 'resend-otp' : '';
  const APPLICATION = app !== 'MSITE' ? 'resend-otp-message' : 'resend-otp-message-msite';
  const OTP_RESEND_MESSAGE = otpSendAgain ? (
    <div className={APPLICATION}>OTP resent to your mobile and Email </div>
  ) : (
    ''
  );

  useEffect(() => {
    if (VerificationPage) {
      gtmEventPush({
        event: 'pageload',
        page_name: 'restore your mobile number | verify details - enter otp',
        page_type: 'restore your mobile number'
      });
    }
  }, []);
  useEffect(()=>{
    if(headerRef.current){
      headerRef.current.focus({ preventScroll: true });
    }
  },[])

  return (
    <div className="otp-container">
      <div className="otp-container__header" role='heading' aria-level={2}>
        <strong ref={headerRef} tabIndex={0}>{label.userProfileOtp}</strong>
      </div>
      <div
        className="otp-container__user-detail"
        dangerouslySetInnerHTML={{ __html: label.userDetail }}
      />
      <div className="otp-container__enter-otp">
        {/* <h1>{label.otpLabel}</h1> */}
        <div className="otp-input-field">
          <input
            type="text"
            id="name"
            name="mobileOTP"
            value={otp}
            maxLength={6}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*$/.test(val) && val.length <= 6) {
                props.handleOTPChange(e);
              }
            }}
            aria-describedby="otp-instruction"
            onKeyPress={e => props.enterPressed(e, otp, USER_MOBILE_NUMBER)}
          />
          <label htmlFor="name">{label.otpLabel}</label>
        </div>

        <div className="otp-error-resend-row">
          <span
            dangerouslySetInnerHTML={{ __html: RESEND_LABEL }}
            className={`${CUSTOM_RESEND}${otpLimitExceeded ? ' resend-otp-disabled' : ''}`}
            tabIndex={otpLimitExceeded ? -1 : 0}
            role="button"
            onClick={() => !otpLimitExceeded && props.resendOTP(USER_MOBILE_NUMBER, USER_EMAIL_ID)}
          />
        </div>
        <div className="otp-status-row">
          <span
            id="otp-instruction"
            className={`${CUSTOM_ERROR_CLASS}`}
            aria-live={CUSTOM_ERROR_CLASS === 'invalid-otp' ? 'polite' : ''}
          >
            {ERROR_MESSAGE}
          </span>
          {otpAttemptCount > 0 && (
            <span className="otp-attempts-left">{attemptsLeft} attempts left</span>
          )}
        </div>
      </div>
      {otpLimitExceeded ? (
        <div
          className="otp-container__submit-otp"
          onClick={onBackToOrderDetails}
          tabIndex={0}
          role="button"
        >
          BACK TO ORDER DETAILS PAGE
        </div>
      ) : (
        <div
          className={`otp-container__submit-otp${otp === '' ? ' otp-container__submit-otp--disabled' : ''}`}
          onClick={otp !== '' ? e => props.submitUserOTP(e, otp, mobileNumber, uid) : undefined}
          tabIndex={otp === '' ? -1 : 0}
          role="button"
        >
          {otpSubmitBtn || label.submit}
        </div>
      )}
      {OTP_RESEND_MESSAGE}
    </div>
  );
};
